﻿export class FileUploadFinished {
    static eventName() { return 'FileUploadFinished' }
    eventName = FileUploadFinished.eventName;
}